document.addEventListener("DOMContentLoaded", function () {

  const radios = document.querySelectorAll('input[name="payment-pack"]');
  const orderBtn = document.querySelector('.order-pack-btn');

  const totalPrice = document.querySelector('.price-info__total b');
  const oldPrice = document.querySelector('.price-info__total del');
  const savePrice = document.querySelector('.price-info__save');

  function updatePack(radio){

    const card = radio.closest('.atc-card');

    const link = card.dataset.link;
    const total = card.dataset.total;
    const old = card.dataset.old;
    const save = card.dataset.save;

    orderBtn.href = link;

    totalPrice.innerText = "$" + total;
    oldPrice.innerText = "$" + old;
    savePrice.innerText = "YOU SAVE $" + save;

  }

  radios.forEach(radio=>{
    radio.addEventListener("change",function(){
      updatePack(this);
    })
  });

  // default selected
  const checked = document.querySelector('input[name="payment-pack"]:checked');
  if(checked){
    updatePack(checked);
  }

});